interface LogoProps {
  className?: string;
  variant?: "default" | "dark" | "auto";
}

export const Logo = ({ className }: LogoProps) => {
  return (
    <>
      <img
        src="/fab-logo-v2/svg/fab-wordmark-light.svg"
        alt="FAB.day"
        className={`h-9 w-auto block dark:hidden ${className ?? ""}`}
      />
      <img
        src="/fab-logo-v2/svg/fab-wordmark-dark.svg"
        alt="FAB.day"
        className={`h-9 w-auto hidden dark:block ${className ?? ""}`}
      />
    </>
  );
};

export const LogoBranded = ({ className }: { className?: string }) => {
  return (
    <>
      <img
        src="/fab-logo-v2/svg/fab-icon-light.svg"
        alt="FAB.day"
        className={`block dark:hidden ${className ?? ""}`}
      />
      <img
        src="/fab-logo-v2/svg/fab-icon-dark.svg"
        alt="FAB.day"
        className={`hidden dark:block ${className ?? ""}`}
      />
    </>
  );
};
